/**
 * DADOS COMPLETOS DE PAÍSES PARA DROPDOWN
 * Arquivo: assets/countries-data.js
 * Uso: Carregado via {{ 'countries-data.js' | asset_url | script_tag }}
 * Acesso: window.COUNTRIES_DATA
 */

window.COUNTRIES_DATA = [
  {
    "letter": "A",
    "countries": [
      {"code": "af", "name": "Afeganistão", "dialCode": "+93"},
      {"code": "al", "name": "Albânia", "dialCode": "+355"},
      {"code": "de", "name": "Alemanha", "dialCode": "+49"},
      {"code": "ad", "name": "Andorra", "dialCode": "+376"},
      {"code": "ao", "name": "Angola", "dialCode": "+244"},
      {"code": "ai", "name": "Anguila", "dialCode": "+1"},
      {"code": "ag", "name": "Antígua e Barbuda", "dialCode": "+1"},
      {"code": "sa", "name": "Arábia Saudita", "dialCode": "+966"},
      {"code": "dz", "name": "Argélia", "dialCode": "+213"},
      {"code": "ar", "name": "Argentina", "dialCode": "+54"},
      {"code": "am", "name": "Armênia", "dialCode": "+374"},
      {"code": "aw", "name": "Aruba", "dialCode": "+297"},
      {"code": "au", "name": "Austrália", "dialCode": "+61"},
      {"code": "az", "name": "Azerbaijão", "dialCode": "+994"}
    ]
  },
  {
    "letter": "Á",
    "countries": [
      {"code": "za", "name": "África do Sul", "dialCode": "+27"},
      {"code": "at", "name": "Áustria", "dialCode": "+43"}
    ]
  },
  {
    "letter": "B",
    "countries": [
      {"code": "bs", "name": "Bahamas", "dialCode": "+1"},
      {"code": "bh", "name": "Bahrein", "dialCode": "+973"},
      {"code": "bd", "name": "Bangladesh", "dialCode": "+880"},
      {"code": "bb", "name": "Barbados", "dialCode": "+1"},
      {"code": "be", "name": "Bélgica", "dialCode": "+32"},
      {"code": "bz", "name": "Belize", "dialCode": "+501"},
      {"code": "bj", "name": "Benin", "dialCode": "+229"},
      {"code": "bm", "name": "Bermudas", "dialCode": "+1"},
      {"code": "by", "name": "Bielorrússia", "dialCode": "+375"},
      {"code": "bo", "name": "Bolívia", "dialCode": "+591"},
      {"code": "ba", "name": "Bósnia e Herzegovina", "dialCode": "+387"},
      {"code": "bw", "name": "Botsuana", "dialCode": "+267"},
      {"code": "br", "name": "Brasil", "dialCode": "+55"},
      {"code": "bn", "name": "Brunei", "dialCode": "+673"},
      {"code": "bg", "name": "Bulgária", "dialCode": "+359"},
      {"code": "bf", "name": "Burquina Faso", "dialCode": "+226"},
      {"code": "bi", "name": "Burundi", "dialCode": "+257"},
      {"code": "bt", "name": "Butão", "dialCode": "+975"}
    ]
  },
  {
    "letter": "C",
    "countries": [
      {"code": "cv", "name": "Cabo Verde", "dialCode": "+238"},
      {"code": "cm", "name": "Camarões", "dialCode": "+237"},
      {"code": "kh", "name": "Camboja", "dialCode": "+855"},
      {"code": "ca", "name": "Canadá", "dialCode": "+1"},
      {"code": "qa", "name": "Catar", "dialCode": "+974"},
      {"code": "kz", "name": "Cazaquistão", "dialCode": "+7"},
      {"code": "td", "name": "Chade", "dialCode": "+235"},
      {"code": "cl", "name": "Chile", "dialCode": "+56"},
      {"code": "cn", "name": "China", "dialCode": "+86"},
      {"code": "cy", "name": "Chipre", "dialCode": "+357"},
      {"code": "va", "name": "Cidade do Vaticano", "dialCode": "+39"},
      {"code": "co", "name": "Colômbia", "dialCode": "+57"},
      {"code": "km", "name": "Comores", "dialCode": "+269"},
      {"code": "cd", "name": "Congo - Kinshasa", "dialCode": "+243"},
      {"code": "kr", "name": "Coreia do Sul", "dialCode": "+82"},
      {"code": "ci", "name": "Costa do Marfim", "dialCode": "+225"},
      {"code": "cr", "name": "Costa Rica", "dialCode": "+506"},
      {"code": "hr", "name": "Croácia", "dialCode": "+385"},
      {"code": "cw", "name": "Curaçao", "dialCode": "+599"}
    ]
  },
  {
    "letter": "D",
    "countries": [
      {"code": "dk", "name": "Dinamarca", "dialCode": "+45"},
      {"code": "dj", "name": "Djibuti", "dialCode": "+253"},
      {"code": "dm", "name": "Dominica", "dialCode": "+1"}
    ]
  },
  {
    "letter": "E",
    "countries": [
      {"code": "eg", "name": "Egito", "dialCode": "+20"},
      {"code": "sv", "name": "El Salvador", "dialCode": "+503"},
      {"code": "ae", "name": "Emirados Árabes Unidos", "dialCode": "+971"},
      {"code": "ec", "name": "Equador", "dialCode": "+593"},
      {"code": "er", "name": "Eritreia", "dialCode": "+291"},
      {"code": "sk", "name": "Eslováquia", "dialCode": "+421"},
      {"code": "si", "name": "Eslovênia", "dialCode": "+386"},
      {"code": "es", "name": "Espanha", "dialCode": "+34"},
      {"code": "sz", "name": "Essuatíni", "dialCode": "+268"},
      {"code": "us", "name": "Estados Unidos", "dialCode": "+1"},
      {"code": "ee", "name": "Estônia", "dialCode": "+372"},
      {"code": "et", "name": "Etiópia", "dialCode": "+251"}
    ]
  },
  {
    "letter": "F",
    "countries": [
      {"code": "fj", "name": "Fiji", "dialCode": "+679"},
      {"code": "ph", "name": "Filipinas", "dialCode": "+63"},
      {"code": "fi", "name": "Finlândia", "dialCode": "+358"},
      {"code": "fr", "name": "França", "dialCode": "+33"}
    ]
  },
  {
    "letter": "G",
    "countries": [
      {"code": "ga", "name": "Gabão", "dialCode": "+241"},
      {"code": "gm", "name": "Gâmbia", "dialCode": "+220"},
      {"code": "gh", "name": "Gana", "dialCode": "+233"},
      {"code": "ge", "name": "Geórgia", "dialCode": "+995"},
      {"code": "gi", "name": "Gibraltar", "dialCode": "+350"},
      {"code": "gd", "name": "Granada", "dialCode": "+1"},
      {"code": "gr", "name": "Grécia", "dialCode": "+30"},
      {"code": "gl", "name": "Groenlândia", "dialCode": "+299"},
      {"code": "gp", "name": "Guadalupe", "dialCode": "+590"},
      {"code": "gu", "name": "Guam", "dialCode": "+1"},
      {"code": "gt", "name": "Guatemala", "dialCode": "+502"},
      {"code": "gg", "name": "Guernsey", "dialCode": "+44"},
      {"code": "gy", "name": "Guiana", "dialCode": "+592"},
      {"code": "gf", "name": "Guiana Francesa", "dialCode": "+594"},
      {"code": "gn", "name": "Guiné", "dialCode": "+224"},
      {"code": "gq", "name": "Guiné Equatorial", "dialCode": "+240"},
      {"code": "gw", "name": "Guiné-Bissau", "dialCode": "+245"}
    ]
  },
  {
    "letter": "H",
    "countries": [
      {"code": "ht", "name": "Haiti", "dialCode": "+509"},
      {"code": "hn", "name": "Honduras", "dialCode": "+504"},
      {"code": "hk", "name": "Hong Kong, RAE da China", "dialCode": "+852"},
      {"code": "hu", "name": "Hungria", "dialCode": "+36"}
    ]
  },
  {
    "letter": "I",
    "countries": [
      {"code": "ye", "name": "Iêmen", "dialCode": "+967"},
      {"code": "ac", "name": "Ilha de Ascensão", "dialCode": "+247"},
      {"code": "im", "name": "Ilha de Man", "dialCode": "+44"},
      {"code": "ax", "name": "Ilhas Aland", "dialCode": "+358"},
      {"code": "ky", "name": "Ilhas Cayman", "dialCode": "+1"},
      {"code": "ck", "name": "Ilhas Cook", "dialCode": "+682"},
      {"code": "fo", "name": "Ilhas Faroe", "dialCode": "+298"},
      {"code": "fk", "name": "Ilhas Malvinas", "dialCode": "+500"},
      {"code": "sb", "name": "Ilhas Salomão", "dialCode": "+677"},
      {"code": "tc", "name": "Ilhas Turcas e Caicos", "dialCode": "+1"},
      {"code": "vg", "name": "Ilhas Virgens Britânicas", "dialCode": "+1"},
      {"code": "id", "name": "Indonésia", "dialCode": "+62"},
      {"code": "iq", "name": "Iraque", "dialCode": "+964"},
      {"code": "ie", "name": "Irlanda", "dialCode": "+353"},
      {"code": "is", "name": "Islândia", "dialCode": "+354"},
      {"code": "il", "name": "Israel", "dialCode": "+972"},
      {"code": "it", "name": "Itália", "dialCode": "+39"}
    ]
  },
  {
    "letter": "Í",
    "countries": [
      {"code": "in", "name": "Índia", "dialCode": "+91"}
    ]
  },
  {
    "letter": "J",
    "countries": [
      {"code": "jm", "name": "Jamaica", "dialCode": "+1"},
      {"code": "jp", "name": "Japão", "dialCode": "+81"},
      {"code": "je", "name": "Jersey", "dialCode": "+44"},
      {"code": "jo", "name": "Jordânia", "dialCode": "+962"}
    ]
  },
  {
    "letter": "K",
    "countries": [
      {"code": "xk", "name": "Kosovo", "dialCode": "+383"},
      {"code": "kw", "name": "Kuwait", "dialCode": "+965"}
    ]
  },
  {
    "letter": "L",
    "countries": [
      {"code": "la", "name": "Laos", "dialCode": "+856"},
      {"code": "ls", "name": "Lesoto", "dialCode": "+266"},
      {"code": "lv", "name": "Letônia", "dialCode": "+371"},
      {"code": "lb", "name": "Líbano", "dialCode": "+961"},
      {"code": "lr", "name": "Libéria", "dialCode": "+231"},
      {"code": "ly", "name": "Líbia", "dialCode": "+218"},
      {"code": "li", "name": "Liechtenstein", "dialCode": "+423"},
      {"code": "lt", "name": "Lituânia", "dialCode": "+370"},
      {"code": "lu", "name": "Luxemburgo", "dialCode": "+352"}
    ]
  },
  {
    "letter": "M",
    "countries": [
      {"code": "mo", "name": "Macau, RAE da China", "dialCode": "+853"},
      {"code": "mk", "name": "Macedônia do Norte", "dialCode": "+389"},
      {"code": "mg", "name": "Madagascar", "dialCode": "+261"},
      {"code": "my", "name": "Malásia", "dialCode": "+60"},
      {"code": "mw", "name": "Malaui", "dialCode": "+265"},
      {"code": "mv", "name": "Maldivas", "dialCode": "+960"},
      {"code": "ml", "name": "Mali", "dialCode": "+223"},
      {"code": "mt", "name": "Malta", "dialCode": "+356"},
      {"code": "ma", "name": "Marrocos", "dialCode": "+212"},
      {"code": "mq", "name": "Martinica", "dialCode": "+596"},
      {"code": "mu", "name": "Maurício", "dialCode": "+230"},
      {"code": "mr", "name": "Mauritânia", "dialCode": "+222"},
      {"code": "yt", "name": "Mayotte", "dialCode": "+262"},
      {"code": "mx", "name": "México", "dialCode": "+52"},
      {"code": "mm", "name": "Mianmar (Birmânia)", "dialCode": "+95"},
      {"code": "mz", "name": "Moçambique", "dialCode": "+258"},
      {"code": "md", "name": "Moldova", "dialCode": "+373"},
      {"code": "mc", "name": "Mônaco", "dialCode": "+377"},
      {"code": "mn", "name": "Mongólia", "dialCode": "+976"},
      {"code": "me", "name": "Montenegro", "dialCode": "+382"},
      {"code": "ms", "name": "Montserrat", "dialCode": "+1"}
    ]
  },
  {
    "letter": "N",
    "countries": [
      {"code": "na", "name": "Namíbia", "dialCode": "+264"},
      {"code": "nr", "name": "Nauru", "dialCode": "+674"},
      {"code": "np", "name": "Nepal", "dialCode": "+977"},
      {"code": "ni", "name": "Nicarágua", "dialCode": "+505"},
      {"code": "ne", "name": "Níger", "dialCode": "+227"},
      {"code": "ng", "name": "Nigéria", "dialCode": "+234"},
      {"code": "nu", "name": "Niue", "dialCode": "+683"},
      {"code": "no", "name": "Noruega", "dialCode": "+47"},
      {"code": "nc", "name": "Nova Caledônia", "dialCode": "+687"},
      {"code": "nz", "name": "Nova Zelândia", "dialCode": "+64"}
    ]
  },
  {
    "letter": "O",
    "countries": [
      {"code": "om", "name": "Omã", "dialCode": "+968"}
    ]
  },
  {
    "letter": "P",
    "countries": [
      {"code": "nl", "name": "Países Baixos", "dialCode": "+31"},
      {"code": "bq", "name": "Países Baixos Caribenhos", "dialCode": "+599"},
      {"code": "pa", "name": "Panamá", "dialCode": "+507"},
      {"code": "pg", "name": "Papua-Nova Guiné", "dialCode": "+675"},
      {"code": "pk", "name": "Paquistão", "dialCode": "+92"},
      {"code": "py", "name": "Paraguai", "dialCode": "+595"},
      {"code": "pe", "name": "Peru", "dialCode": "+51"},
      {"code": "pf", "name": "Polinésia Francesa", "dialCode": "+689"},
      {"code": "pl", "name": "Polônia", "dialCode": "+48"},
      {"code": "pr", "name": "Porto Rico", "dialCode": "+1"},
      {"code": "pt", "name": "Portugal", "dialCode": "+351"}
    ]
  },
  {
    "letter": "Q",
    "countries": [
      {"code": "ke", "name": "Quênia", "dialCode": "+254"},
      {"code": "kg", "name": "Quirguistão", "dialCode": "+996"},
      {"code": "ki", "name": "Quiribati", "dialCode": "+686"}
    ]
  },
  {
    "letter": "R",
    "countries": [
      {"code": "gb", "name": "Reino Unido", "dialCode": "+44"},
      {"code": "cf", "name": "República Centro-Africana", "dialCode": "+236"},
      {"code": "cg", "name": "República do Congo", "dialCode": "+242"},
      {"code": "do", "name": "República Dominicana", "dialCode": "+1"},
      {"code": "re", "name": "Reunião", "dialCode": "+262"},
      {"code": "ro", "name": "Romênia", "dialCode": "+40"},
      {"code": "rw", "name": "Ruanda", "dialCode": "+250"},
      {"code": "ru", "name": "Rússia", "dialCode": "+7"}
    ]
  },
  {
    "letter": "S",
    "countries": [
      {"code": "eh", "name": "Saara Ocidental", "dialCode": "+212"},
      {"code": "ws", "name": "Samoa", "dialCode": "+685"},
      {"code": "sm", "name": "San Marino", "dialCode": "+378"},
      {"code": "sh", "name": "Santa Helena", "dialCode": "+290"},
      {"code": "lc", "name": "Santa Lúcia", "dialCode": "+1"},
      {"code": "bl", "name": "São Bartolomeu", "dialCode": "+590"},
      {"code": "kn", "name": "São Cristóvão e Névis", "dialCode": "+1"},
      {"code": "mf", "name": "São Martinho", "dialCode": "+590"},
      {"code": "pm", "name": "São Pedro e Miquelão", "dialCode": "+508"},
      {"code": "st", "name": "São Tomé e Príncipe", "dialCode": "+239"},
      {"code": "vc", "name": "São Vicente e Granadinas", "dialCode": "+1"},
      {"code": "sc", "name": "Seicheles", "dialCode": "+248"},
      {"code": "sn", "name": "Senegal", "dialCode": "+221"},
      {"code": "sl", "name": "Serra Leoa", "dialCode": "+232"},
      {"code": "rs", "name": "Sérvia", "dialCode": "+381"},
      {"code": "sg", "name": "Singapura", "dialCode": "+65"},
      {"code": "sx", "name": "Sint Maarten", "dialCode": "+1"},
      {"code": "so", "name": "Somália", "dialCode": "+252"},
      {"code": "lk", "name": "Sri Lanka", "dialCode": "+94"},
      {"code": "ss", "name": "Sudão do Sul", "dialCode": "+211"},
      {"code": "se", "name": "Suécia", "dialCode": "+46"},
      {"code": "ch", "name": "Suíça", "dialCode": "+41"},
      {"code": "sr", "name": "Suriname", "dialCode": "+597"},
      {"code": "sj", "name": "Svalbard e Jan Mayen", "dialCode": "+47"}
    ]
  },
  {
    "letter": "T",
    "countries": [
      {"code": "tj", "name": "Tadjiquistão", "dialCode": "+992"},
      {"code": "th", "name": "Tailândia", "dialCode": "+66"},
      {"code": "tw", "name": "Taiwan", "dialCode": "+886"},
      {"code": "tz", "name": "Tanzânia", "dialCode": "+255"},
      {"code": "cz", "name": "Tchéquia", "dialCode": "+420"},
      {"code": "io", "name": "Território Britânico do Oceano Índico", "dialCode": "+246"},
      {"code": "ps", "name": "Territórios palestinos", "dialCode": "+970"},
      {"code": "tl", "name": "Timor-Leste", "dialCode": "+670"},
      {"code": "tg", "name": "Togo", "dialCode": "+228"},
      {"code": "tk", "name": "Tokelau", "dialCode": "+690"},
      {"code": "to", "name": "Tonga", "dialCode": "+676"},
      {"code": "tt", "name": "Trinidad e Tobago", "dialCode": "+1"},
      {"code": "ta", "name": "Tristão da Cunha", "dialCode": "+290"},
      {"code": "tn", "name": "Tunísia", "dialCode": "+216"},
      {"code": "tm", "name": "Turcomenistão", "dialCode": "+993"},
      {"code": "tr", "name": "Turquia", "dialCode": "+90"},
      {"code": "tv", "name": "Tuvalu", "dialCode": "+688"}
    ]
  },
  {
    "letter": "U",
    "countries": [
      {"code": "ua", "name": "Ucrânia", "dialCode": "+380"},
      {"code": "ug", "name": "Uganda", "dialCode": "+256"},
      {"code": "uy", "name": "Uruguai", "dialCode": "+598"},
      {"code": "uz", "name": "Uzbequistão", "dialCode": "+998"}
    ]
  },
  {
    "letter": "V",
    "countries": [
      {"code": "vu", "name": "Vanuatu", "dialCode": "+678"},
      {"code": "ve", "name": "Venezuela", "dialCode": "+58"},
      {"code": "vn", "name": "Vietnã", "dialCode": "+84"}
    ]
  },
  {
    "letter": "W",
    "countries": [
      {"code": "wf", "name": "Wallis e Futuna", "dialCode": "+681"}
    ]
  },
  {
    "letter": "Z",
    "countries": [
      {"code": "zm", "name": "Zâmbia", "dialCode": "+260"},
      {"code": "zw", "name": "Zimbábue", "dialCode": "+263"}
    ]
  }
];

/**
 * FORMATAÇÕES DE TELEFONE POR PAÍS
 * Baseado em pesquisa de formatos internacionais 2025
 * Usado para formatar automaticamente conforme o país selecionado
 */
window.PHONE_FORMATS = {
  // === AMÉRICA DO NORTE (NANP) ===
  "+1": { format: "(###) ###-####", placeholder: "(555) 123-4567" }, // EUA, Canadá, Caribe
  
  // === AMÉRICA DO SUL ===
  "+54": { format: "## ####-####", placeholder: "11 1234-5678" }, // Argentina
  "+55": { format: "(##) # ####-####", placeholder: "(11) 9 9999-9999" }, // Brasil
  "+56": { format: "# #### ####", placeholder: "9 1234 5678" }, // Chile
  "+57": { format: "### ### ####", placeholder: "312 345 6789" }, // Colômbia
  "+51": { format: "### ### ###", placeholder: "912 345 678" }, // Peru
  "+598": { format: "## ### ###", placeholder: "99 123 456" }, // Uruguai
  "+58": { format: "###-### ####", placeholder: "412-123 4567" }, // Venezuela
  "+595": { format: "### ### ###", placeholder: "981 123 456" }, // Paraguai
  "+591": { format: "# ### ####", placeholder: "7 123 4567" }, // Bolívia
  "+593": { format: "## ### ####", placeholder: "99 123 4567" }, // Equador
  
  // === AMÉRICA CENTRAL E CARIBE ===
  "+52": { format: "## #### ####", placeholder: "55 1234 5678" }, // México
  "+501": { format: "### ####", placeholder: "223 4567" }, // Belize
  "+502": { format: "#### ####", placeholder: "5123 4567" }, // Guatemala
  "+503": { format: "#### ####", placeholder: "7123 4567" }, // El Salvador
  "+504": { format: "#### ####", placeholder: "9123 4567" }, // Honduras
  "+505": { format: "#### ####", placeholder: "8123 4567" }, // Nicarágua
  "+506": { format: "#### ####", placeholder: "8123 4567" }, // Costa Rica
  "+507": { format: "#### ####", placeholder: "6123 4567" }, // Panamá
  
  // === EUROPA ===
  "+43": { format: "### ### ####", placeholder: "664 123 4567" }, // Áustria
  "+32": { format: "### ## ## ##", placeholder: "470 12 34 56" }, // Bélgica
  "+45": { format: "## ## ## ##", placeholder: "20 12 34 56" }, // Dinamarca
  "+34": { format: "### ### ###", placeholder: "612 345 678" }, // Espanha
  "+358": { format: "## ### ####", placeholder: "50 123 4567" }, // Finlândia
  "+33": { format: "# ## ## ## ##", placeholder: "6 12 34 56 78" }, // França
  "+49": { format: "### ### ####", placeholder: "151 234 5678" }, // Alemanha
  "+30": { format: "### ### ####", placeholder: "694 123 4567" }, // Grécia
  "+31": { format: "## ### ####", placeholder: "06 123 4567" }, // Holanda
  "+353": { format: "## ### ####", placeholder: "85 123 4567" }, // Irlanda
  "+354": { format: "### ####", placeholder: "581 2345" }, // Islândia
  "+39": { format: "### ### ####", placeholder: "320 123 4567" }, // Itália
  "+47": { format: "### ## ###", placeholder: "406 12 345" }, // Noruega
  "+48": { format: "### ### ###", placeholder: "501 234 567" }, // Polônia
  "+351": { format: "### ### ###", placeholder: "912 345 678" }, // Portugal
  "+44": { format: "#### ######", placeholder: "7911 123456" }, // Reino Unido
  "+7": { format: "### ###-##-##", placeholder: "916 123-45-67" }, // Rússia
  "+46": { format: "##-### ## ##", placeholder: "70-123 45 67" }, // Suécia
  "+41": { format: "## ### ## ##", placeholder: "79 123 45 67" }, // Suíça
  "+356": { format: "#### ####", placeholder: "2123 4567" }, // Malta
  "+357": { format: "#### ####", placeholder: "2234 5678" }, // Chipre
  "+382": { format: "## ### ###", placeholder: "67 123 456" }, // Montenegro
  "+373": { format: "#### ####", placeholder: "6912 3456" }, // Moldávia
  "+355": { format: "## ### ####", placeholder: "69 123 4567" }, // Albânia
  "+389": { format: "## ### ###", placeholder: "70 123 456" }, // Macedônia do Norte
  "+380": { format: "## ### ## ##", placeholder: "50 123 45 67" }, // Ucrânia
  "+420": { format: "### ### ###", placeholder: "601 123 456" }, // Tchéquia
  "+421": { format: "### ### ###", placeholder: "905 123 456" }, // Eslováquia
  "+36": { format: "## ### ####", placeholder: "20 123 4567" }, // Hungria
  "+40": { format: "### ### ###", placeholder: "722 123 456" }, // Romênia
  "+385": { format: "##-###-####", placeholder: "91-234-5678" }, // Croácia
  "+381": { format: "##-###-####", placeholder: "63-123-4567" }, // Sérvia
  "+386": { format: "## ### ###", placeholder: "31 123 456" }, // Eslovênia
  "+372": { format: "### ####", placeholder: "512 3456" }, // Estônia
  "+371": { format: "## ### ###", placeholder: "21 234 567" }, // Letônia
  "+370": { format: "### #####", placeholder: "612 34567" }, // Lituânia
  "+359": { format: "### ### ###", placeholder: "887 123 456" }, // Bulgária
  
  // === ÁSIA ===
  "+86": { format: "### #### ####", placeholder: "138 0013 8000" }, // China
  "+82": { format: "##-####-####", placeholder: "10-1234-5678" }, // Coreia do Sul
  "+91": { format: "##### #####", placeholder: "98765 43210" }, // Índia
  "+62": { format: "###-###-####", placeholder: "812-345-6789" }, // Indonésia
  "+81": { format: "##-####-####", placeholder: "90-1234-5678" }, // Japão
  "+60": { format: "##-### ####", placeholder: "12-345 6789" }, // Malásia
  "+63": { format: "### ### ####", placeholder: "917 123 4567" }, // Filipinas
  "+65": { format: "#### ####", placeholder: "9123 4567" }, // Singapura
  "+66": { format: "##-###-####", placeholder: "81-234-5678" }, // Tailândia
  "+84": { format: "### ### ####", placeholder: "912 345 678" }, // Vietnã
  "+92": { format: "### ### ####", placeholder: "300 123 4567" }, // Paquistão
  "+94": { format: "## ### ####", placeholder: "71 234 5678" }, // Sri Lanka
  "+880": { format: "1### ######", placeholder: "1712 345678" }, // Bangladesh
  "+977": { format: "### ### ####", placeholder: "980 123 4567" }, // Nepal
  "+95": { format: "# ### ####", placeholder: "9 123 4567" }, // Mianmar
  "+998": { format: "## ### ####", placeholder: "90 123 4567" }, // Uzbequistão
  "+93": { format: "## ### ####", placeholder: "70 123 4567" }, // Afeganistão
  "+996": { format: "### ### ###", placeholder: "700 123 456" }, // Quirguistão
  "+992": { format: "### ### ###", placeholder: "917 123 456" }, // Tadjiquistão
  
  // === ORIENTE MÉDIO ===
  "+966": { format: "## ### ####", placeholder: "50 123 4567" }, // Arábia Saudita
  "+971": { format: "# ### ####", placeholder: "4 123 4567" }, // Emirados Árabes Unidos
  "+974": { format: "#### ####", placeholder: "4412 3456" }, // Catar
  "+965": { format: "#### ####", placeholder: "2234 5678" }, // Kuwait
  "+973": { format: "#### ####", placeholder: "1234 5678" }, // Bahrein
  "+968": { format: "#### ####", placeholder: "2412 3456" }, // Omã
  "+972": { format: "##-###-####", placeholder: "50-123-4567" }, // Israel
  "+962": { format: "# #### ####", placeholder: "7 9012 3456" }, // Jordânia
  "+961": { format: "## ### ###", placeholder: "70 123 456" }, // Líbano
  "+98": { format: "## #### ####", placeholder: "21 1234 5678" }, // Irã
  "+964": { format: "# #### ####", placeholder: "1 234 5678" }, // Iraque
  "+90": { format: "### ### ## ##", placeholder: "532 123 45 67" }, // Turquia
  
  // === ÁFRICA ===
  "+27": { format: "## ### ####", placeholder: "82 123 4567" }, // África do Sul
  "+20": { format: "### ### ####", placeholder: "100 123 4567" }, // Egito
  "+212": { format: "### ### ###", placeholder: "612 345 678" }, // Marrocos
  "+213": { format: "### ### ###", placeholder: "551 234 567" }, // Argélia
  "+216": { format: "## ### ###", placeholder: "71 123 456" }, // Tunísia
  "+218": { format: "## ### ####", placeholder: "21 234 5678" }, // Líbia
  "+233": { format: "### ### ###", placeholder: "244 123 456" }, // Gana
  "+234": { format: "### ### ####", placeholder: "803 123 4567" }, // Nigéria
  "+251": { format: "## ### ####", placeholder: "11 123 4567" }, // Etiópia
  "+254": { format: "### ### ###", placeholder: "712 345 678" }, // Quênia
  "+255": { format: "### ### ###", placeholder: "754 123 456" }, // Tanzânia
  "+256": { format: "### ### ###", placeholder: "712 345 678" }, // Uganda
  "+260": { format: "### ### ###", placeholder: "977 123 456" }, // Zâmbia
  "+263": { format: "### ### ###", placeholder: "912 345 678" }, // Zimbábue
  "+265": { format: "# #### ####", placeholder: "1 2345 6789" }, // Malawi
  "+267": { format: "## ### ###", placeholder: "71 123 456" }, // Botsuana
  "+268": { format: "#### ####", placeholder: "7612 3456" }, // Essuatíni
  
  // === OCEANIA ===
  "+61": { format: "### ### ###", placeholder: "412 345 678" }, // Austrália
  "+64": { format: "##-###-####", placeholder: "21-123-4567" }, // Nova Zelândia
  "+679": { format: "### ####", placeholder: "123 4567" }, // Fiji
  "+675": { format: "### ####", placeholder: "712 3456" }, // Papua Nova Guiné
  
  // === PADRÃO GENÉRICO PARA PAÍSES NÃO LISTADOS ===
  "generic": { format: "### ### ####", placeholder: "123 456 7890" } // Usado quando país não tem formato específico
};